import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { AlertTriangle } from "lucide-react";

/**
 * Storm Mode overlay — polls /api/weather/alerts and, when a Tornado Warning is
 * active in Georgia, applies a fixed red-strobing frame + a persistent top strip
 * so viewers on ANY page (home, broadcast, admin) know severe weather is ongoing.
 */
export default function StormModeBanner() {
  const [storm, setStorm] = useState(null); // { active, alerts }

  useEffect(() => {
    const load = () => {
      api.get("/weather/alerts")
        .then((r) => setStorm({ active: !!r.data.storm_mode, alerts: r.data.tornado_alerts || [] }))
        .catch(() => {});
    };
    load();
    const t = setInterval(load, 30_000);
    return () => clearInterval(t);
  }, []);

  if (!storm?.active) return null;

  const first = storm.alerts[0] || { title: "Tornado Warning", area: "Georgia" };

  return (
    <>
      {/* Full-viewport strobing red frame */}
      <div
        data-testid="storm-mode-frame"
        className="pointer-events-none fixed inset-0 z-[60] storm-strobe"
        style={{
          boxShadow: "inset 0 0 0 8px #d90429, inset 0 0 60px rgba(217,4,41,0.55)",
        }}
      />
      {/* Persistent top strip */}
      <div
        data-testid="storm-mode-banner"
        className="fixed inset-x-0 top-0 z-[70] flex items-center gap-3 border-b-2 border-black bg-[#d90429] px-4 py-2 shadow-[0_6px_30px_rgba(217,4,41,0.7)]"
      >
        <AlertTriangle className="h-5 w-5 shrink-0 text-white storm-flash" />
        <div className="flex-1 truncate font-oswald text-sm font-bold uppercase tracking-[0.3em] text-white sm:text-base">
          {first.title} · In Effect for {first.area || "Georgia"}
        </div>
        <div className="hidden rounded bg-black/40 px-2 py-0.5 font-mono text-[10px] uppercase tracking-widest text-white sm:block">
          {storm.alerts.length} active
        </div>
      </div>
    </>
  );
}
